<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :chartProperties="chartProperties"
    :chartData="chartGraphData"
    :selectedComponent="selectedChartComponent"
    :addButtonText="addButtonText"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :singleHeading="singleHeading"
    :isShowHint="isShowHint"
    :infoText="infoText"
    :infoError="infoError"
    :emptyChartMessage="emptyChartMessage"
    @addRow="addRow"
    @editableRowButtonClick="genericMethodClick"
    @setFocusOnRowElement="setFocusOnRowElement"
    :focusElementName="focusElementName"
    :gridButtonTemplate="gridButtonTemplate"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @rowTemplateButtonClick="genericMethodClick"
    @OuterRowButtonClick="genericMethodClick"
    :rowOuterButton="rowOuterButton"
    @onChange="OnOptionChange"
    :emptyGridData="emptyGridData"
    @removeRow="removeRow"
    @onChangeChartTab="onChangeChartTab"
    :tableViewSettings="tableSetting"
    :showTableView="showTable"
    :buttonDataTypeConfig="buttonDataTypeConfig"
    :buttonViewTypeConfig="buttonViewTypeConfig"
    @onSelectDataTypeFilter="onSelectDataTypeFilter"
    @onSelectViewTypeFilter="onSelectViewTypeFilter"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { LoanAdvanceFilterContent } from "../../mixin";
import { AdvanceFilter, DATETYPE } from "../../helpers/constant";

import { mapGetters } from "vuex";
import { GET_LIABLITY_INFORMATION } from "../../helpers/vuex-constants";
import _ from "lodash";
import { GET_SELECTED_LIABLITY_INFORMATION } from "../../helpers/vuex-constants";
import { ICELoanIntegration } from "../../mixin";
export default {
  props: {
    tableViewSettings: {
      type: Object,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    baselineData: {
      type: Object,
    },
  },
  components: { ToolAdvanceFilterContent },
  computed: {
    gridButtonTemplate() {
      let difference = true;
      let Loans = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      let ExistingData = Loans[0].advancedetails
        .filter((sr) => sr.typeId == AdvanceFilter.DrawDown)
        .map(function (t) {
          let p = {};
          //   p.effectiveAsON = t.effectiveAsON;
          p.subTypeId = t.subTypeId.toString();
          p.index = t.index.toString();
          //  p.effectiveAsON = t.effectiveAsON;
          p.frequency = t.frequency;
          p.startDate = t.startDate;
          p.startDateType = t.startDateType.toString();
          p.endDate = t.endDate;
          p.endDateType = t.endDateType.toString();
          p.amount = t.amount;
          p.description = t.description;
          return p;
        });

      let CurrentDataObject = [];

      for (let i = 0; i < this.rows.length; i++) {
        if (ExistingData.length > 0)
          CurrentDataObject.push({
            // effectiveAsON: this.rows[i].EffectiveAsON.value,
            subTypeId: this.rows[i].subTypeId.value.toString(),
            index: this.rows[i].Index.value.toString(),
            //   effectiveAsON: this.rows[i].EffectiveAsON.value,
            frequency: this.rows[i].Frequency.value,
            startDate: this.rows[i].StartDate.value,
            startDateType: this.rows[i].StartDateType.value.toString(),
            endDate: this.rows[i].EndDate.value,
            endDateType: this.rows[i].EndDateType.value.toString(),
            amount: this.rows[i].Amount.value,
            description: this.rows[i].Description.value,
          });
        else {
          if (!this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)) {
            difference = false;
            break;
          }
        }
      }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
    legendItems() {
      return ["", "Additional Drawdowns"];
    },
    baselineFilterObject() {
      return Object.assign({}, this.baselineData);
    },
    ...mapGetters("loan", {
      selectedLoanData: GET_SELECTED_LIABLITY_INFORMATION,
      getLiablityInformation: GET_LIABLITY_INFORMATION,
    }),
  },
  mixins: [LoanAdvanceFilterContent, ICELoanIntegration],
  mounted() {
    this.fillLoanModel(AdvanceFilter.DrawDown);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.DrawDown
    );
  },
  data() {
    return {
      buttonDataTypeConfig: [],
      buttonViewTypeConfig: [],
      emptyGridData: {
        title: "Click to add Additional Drawdowns",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      rowOuterButton: [
        // {
        //   icon: "trash",
        //   size: "large",
        //   variation: "icon-only",
        //   text: "Add New",
        //   callBackMethod: "DeleteSubtype",
        //   isdisabled: false,
        //   key: "deletesubtype",
        // },
      ],
      focusElementName: "",
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Preview Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],
      timeSeriesChartData: this.getTimeSeriesCoordinate(
        this.baselineData.advancedetails,
        AdvanceFilter.DrawDown,
        this.baselineData.projectionYear
      ),
      emptyChartMessage: {
        message: "Add Drawdown details to create a chart.",
        btnTxt: "",
      },
      contentInfo: {
        heading: "Drawdown",
        subHeading:
          "You can enter in drawdown details at different time periods.",
        infoAlert: {
          title: "Important note",
          variation: "informational",
          text: "Setting loan drawdown amount to 0 will auto calculate the drawdown based on the amount owing, interest rate and remaining term.",
        },
      },
      updateButtonText: "Update Graph",
      addButtonText: "Add new",
      isShowHint: true,
      infoText: ["Hit 'Tab' to move to the next cell and add a new row"],
      singleHeadingOptions: [
        {
          key: 2,
          value: "Regular",
          fields: [
            "Amount",
            "Index",
            "Frequency",

            "StartDate",

            "EndDate",
            "Description",
          ],
          overlapvalidations: true,
        },
        {
          key: 1,
          value: "Lump Sum",
          fields: ["Amount", "StartDate", "Description", "EffectiveAsON"],
          overlapvalidations: false,
          showDateLabel: true,
        },
      ],
      singleHeadingButtonText: "",
      gridSplitId: "subTypeId",

      infoError: false,
      singleHeading: "Additional Drawdowns",
      headers: [
        // {
        //   type: "Dropdown",
        //   label: "Repayment Type",
        //   cols: 2,
        //   key: "RepaymentType",
        //   options: [
        //     {
        //       text: "Interest Only",
        //       value: "1",
        //     },
        //     {
        //       text: "Principal and Interest",
        //       value: "0",
        //     },
        //   ],
        //   defaultValue: "1",
        // },

        {
          type: "FormatInput",
          label: "Amount",
          cols: 2,
          key: "Amount",
          isAllowOnlyNumber: true,
          appendText: "",
          currencyFormat: "$,",

          max: 999999999,
          length: 9,
          validation: true,
          style: {
            width: "160px",
            overflow: "visible",
          },
        },
        {
          type: "Dropdown",
          label: "Index",
          cols: 1,
          key: "Index",
          options: this.indexOptions(),
          defaultValue: "AWOTE",
          validation: true,
          style: {
            width: "160px",
            overflow: "visible",
          },
        },
        {
          type: "Dropdown",
          label: "Frequency",
          cols: 1,
          key: "Frequency",
          options: this.frequencyOption(),
          defaultValue: "Weekly",
          validation: true,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: false,
          typing: true,
          label: "Start",
          text: "Date",
          cols: 1,
          key: "StartDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Dropdown",
          label: "Effective as on",
          cols: 2,
          Option: "",
          key: "EffectiveAsON",
          options: [
            {
              text: "Start of the month",
              value: "1",
            },
            {
              text: "End of the month",
              value: "2",
            },
          ],
          defaultValue: 1,
          validation: true,
          style: {
            width: "160px",
            overflow: "visible",
          },
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: true,
          typing: true,
          label: "End",
          cols: 1,
          key: "EndDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          cols: 2,
          Option: "",
          key: "Description",
          length: 200,
        },

        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
    };
  },
  async created() {
    this.setChartViewTypeDropDown();
    this.setChartDataTypeDropDown();
  },
  beforeMount() {
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.DrawDown
    );
  },
  beforeDestroy() {
    this.fillLoanModel(AdvanceFilter.DrawDown);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.DrawDown
    );
  },
  methods: {
    DeleteSubtype(data) {
      if (data && this.rows)
        this.rows = this.rows.filter((x) => x.subTypeId.value != data);
    },

    fillGrid() {
      let gridRows = [];

      if (this.baselineData.advancedetails != null) {
        // console.log(JSON.stringify(this.baselineData.advancedetails));

        let data = this.baselineData.advancedetails.filter(
          (sr) => sr.typeId.value == AdvanceFilter.DrawDown
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
        // this.getinsertEmptyRows(gridRows);
      }
      // if (this.baselineData.advancedetails == null) {
      //   gridRows.push(this.emptyGridRow());
      // } else {
      //   let data = this.baselineData.advancedetails.filter(
      //     (sr) => sr.typeId.value == AdvanceFilter.DrawDown
      //   );
      //   if (data == null || data.length == 0) {
      //     gridRows.push(this.emptyGridRow());
      //   } else {
      //     gridRows = this.emptyGridRow(data);
      //   }
      // }
      return gridRows;
    },

    async UpdateGraph() {
      this.fillLoanModel(AdvanceFilter.DrawDown);
      if (
        !this.validations(
          this.baselineFilterObject.advancedetails,
          AdvanceFilter.DrawDown
        )
      ) {
        await this.UpdateGraphByICEApi();
        this.timeSeriesChartData = this.getTimeSeriesCoordinate(
          this.baselineFilterObject.advancedetails,
          AdvanceFilter.DrawDown,
          this.baselineData.projectionYear
        );
        this.onChangeChartTab(this.selectedChartComponent);
      }
    },
    getUserInputData(userInputRows) {
      let addtionalData = [];
      let rows = Object.assign([], userInputRows);
      rows = this.ResetMonthPickerValue(rows);
      if (userInputRows)
        for (let i = 0; i < rows.length; i++) {
          if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
            addtionalData.push({
              subTypeId: {
                value: rows[i].subTypeId.value,
                IsError: false,
                ErrorText: [],
              },
              index: {
                value: rows[i].Index.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].Index.disable,
              },
              amount: {
                value: rows[i].Amount.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].Amount.disable,
              },
              frequency: {
                value: rows[i].Frequency.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].Frequency.disable,
              },
              startDateType: {
                value: rows[i].StartDateType.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].StartDateType.disable,
              },
              startDate: {
                value: rows[i].StartDate.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].StartDate.disable,
              },
              endDate: {
                value: rows[i].EndDate.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].EndDate.disable,
              },
              endDateType: {
                value: rows[i].EndDateType.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].EndDateType.disable,
              },
              effectiveAsON: {
                value: rows[i].EffectiveAsON.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].EffectiveAsON.disable,
              },
              description: {
                value: rows[i].Description.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].Description.disable,
              },
              typeId: { value: AdvanceFilter.DrawDown },
              newRow: false,
            });
          }
        }
      return addtionalData;
    },
    setFocusOnRowElement() {
      this.focusElementName = this.headers[0].key + "0";
    },
    fillData(data, subTypeId = 0) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? DATETYPE.Other
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? DATETYPE.Other
        : data.endDateType.value;
      if (subTypeId == 0 && !IsDataundfined) {
        subTypeId = data.subTypeId.value;
      }
      let emptyObject = {
        subTypeId: {
          value: subTypeId.toString(),
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        Index: {
          value: IsDataundfined ? 0 : data.index.value,
          IsError: IsDataundfined ? false : data.index.IsError,
          ErrorText: IsDataundfined ? [] : data.index.ErrorText,
          disable: IsDataundfined ? false : data.index.disable,
        },
        Amount: {
          value: IsDataundfined ? 0 : data.amount.value,
          IsError: IsDataundfined ? false : data.amount.IsError,
          ErrorText: IsDataundfined ? [] : data.amount.ErrorText,
          disable: IsDataundfined ? false : data.amount.disable,
        },
        Frequency: {
          value: IsDataundfined ? 0 : data.frequency.value,
          IsError: IsDataundfined ? false : data.frequency.IsError,
          ErrorText: IsDataundfined ? [] : data.frequency.ErrorText,
          disable: IsDataundfined ? false : data.frequency.disable,
        },
        StartDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        StartDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,

          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        EndDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        EndDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,

          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        EffectiveAsON: {
          value: IsDataundfined ? 0 : data.effectiveAsON.value,
          IsError: IsDataundfined ? false : data.effectiveAsON.IsError,
          ErrorText: IsDataundfined ? [] : data.effectiveAsON.ErrorText,
          disable: IsDataundfined ? false : data.effectiveAsON.disable,
        },
        Description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },

    reset() {
      let Loans = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      let selectedRepData = Loans[0].advancedetails.filter(
        (sr) => sr.typeId == AdvanceFilter.DrawDown
      );
      if (selectedRepData.length > 0) {
        let advanceData = [];
        for (let i = 0; i < selectedRepData.length; i++) {
          advanceData.push({
            subTypeId: {
              value: selectedRepData[i].subTypeId,
            },
            EffectiveAsON: {
              value: selectedRepData[i].effectiveAsON,
            },
            Index: {
              value: selectedRepData[i].index,
            },
            Frequency: {
              value: selectedRepData[i].frequency,
            },
            Amount: {
              value: selectedRepData[i].amount,
            },
            StartDate: {
              value: selectedRepData[i].startDate,
              disable:
                selectedRepData[i].startDateType != DATETYPE.Other
                  ? true
                  : false,
            },
            StartDateType: {
              value: selectedRepData[i].startDateType,
            },
            EndDate: {
              value: selectedRepData[i].endDate,
              disable:
                selectedRepData[i].endDateType != DATETYPE.Other ? true : false,
            },
            EndDateType: {
              value: selectedRepData[i].endDateType,
            },
            Description: {
              value: selectedRepData[i].description,
            },
            typeId: {
              value: AdvanceFilter.DrawDown,
            },
          });
        }
        this.rows = advanceData;
      } else {
        this.rows = [];
      }
      this.getinsertEmptyRows(this.rows);
      this.enableResetButton(false, "reset");
    },
  },
};
</script>
<style lang="scss" module></style>
